import { useState } from 'react';
import Button from '../../../../../ui/button/button';
import FontAwesomeIcon from '../../../../../ui/font-awesome-icon/font-awesome-icon';
import SharedModal from '../../../../../ui/modal/shared-modal';
import qualityEvents from '../../../../../services/quality-events/quality-events';
import { PAYMENT_METHOD_KEYS } from '../../../payment.constants';
import { useAppSelector } from '../../../../../store';
import './carta-del-docente-button.scss';

const BORGIONE_URL = 'https://www.borgione.it/catalogsearch/result?q=eduki%2B';

const CartaDelDocenteButton = () => {
    const user = useAppSelector((state: RootState) => state.main.user);
    const { paymentCart } = useAppSelector((state: RootState) => state.payment);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleOpenModal = () => {
        qualityEvents.checkoutPage.startPayment(user.id, PAYMENT_METHOD_KEYS.CARTA_DEL_DOCENTE, paymentCart?.finalPrice);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        qualityEvents.checkoutPage.abandonedPayment(user.id, PAYMENT_METHOD_KEYS.CARTA_DEL_DOCENTE, paymentCart?.finalPrice);
        setIsModalOpen(false);
    };

    const handleContinue = () => {
        qualityEvents.checkoutPage.cartaDelDocenteContinue();
        setIsModalOpen(false);
        window.open(BORGIONE_URL, '_blank');
    };

    const modalBody = (
        <>
            <p>Per pagare con la Carta del Docente, segui questi passaggi:</p>
            <ol>
                <li>
                    Verrai reindirizzato sulla piattaforma Borgione per acquistare un voucher utilizzando il tuo bonus
                    Carta del Docente. È necessario avere un account eduki prima dell&apos;acquisto.
                </li>
                <li>
                    Riceverai una conferma da Borgione. Entro poche ore aggiungeremo i crediti di pari valore del
                    voucher acquistato al tuo account eduki. La sera e nei weekend, potrebbero essere necessarie fino
                    a 48 ore.
                </li>
                <li>
                    Torna su eduki per completare il tuo acquisto. Non dimenticare di utilizzare i tuoi crediti al
                    momento del pagamento.
                </li>
            </ol>
            <p className='warning-note'>
                <FontAwesomeIcon height={24} name='warning-triangle' theme='yellow' />
                <span>Non completare questo ordine con un altro metodo di pagamento. Attendi che i tuoi crediti vengano aggiunti.</span>
            </p>
        </>
    );

    const modalBtnConfig = [
        {
            action: handleCancel,
            className: 'styled secondary',
            text: 'Annulla'
        },
        {
            action: handleContinue,
            className: 'styled yellow',
            text: <>Continua su Borgione <FontAwesomeIcon height={24} name='open-in' /></>
        }
    ];

    return (
        <>
            <Button variant='btn-lg yellow' onClick={handleOpenModal}>
                Continua con Carta del Docente
            </Button>
            {isModalOpen && (
                <SharedModal
                    title={<>Attenzione! Questo non è un pagamento istantaneo</>}
                    body={modalBody}
                    btnConfig={modalBtnConfig}
                    onClose={handleCancel}
                    dialogClassName='carta-del-docente-modal'
                />
            )}
        </>
    );
};

export default CartaDelDocenteButton;
